/** Admin "Wash Tiers & Upsells" for one owner (owner-twin via makeOwnerApi). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { makeOwnerApi } from '../../../../../src/api/adminAsOwner';
import WashTiersScreen from '../../../../../src/screens/WashTiersScreen';
import type { TierApiClient } from '../../../../../src/screens/FleetTiersScreen';

export default function AdminOwnerWashesUpsellsScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const client = React.useMemo<TierApiClient>(() => makeOwnerApi(id ?? ''), [id]);
  return <WashTiersScreen client={client} adminOwnerId={id} />;
}
